// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 675) return "static/chunks/675-b36536dff14cbbe1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"199":"863eb1d83c2c3bcb","855":"05f82228bf2780f9"}[chunkId] + ".js";
};